// @generated by protoc-gen-es v2.2.1 with parameter "target=dts+js"
// @generated from file admin-auth-main/pinup/google_auth/simple/service.proto (package pinup.google_auth.simple, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file admin-auth-main/pinup/google_auth/simple/service.proto.
 */
export const file_admin_auth_main_pinup_google_auth_simple_service = /*@__PURE__*/
  fileDesc("CjZhZG1pbi1hdXRoLW1haW4vcGludXAvZ29vZ2xlX2F1dGgvc2ltcGxlL3NlcnZpY2UucHJvdG8SGHBpbnVwLmdvb2dsZV9hdXRoLnNpbXBsZSIeCg1TaWduSW5SZXF1ZXN0Eg0KBXRva2VuGAEgASgJIlgKDlNpZ25JblJlc3BvbnNlEg8KB3JlZnJlc2gYASABKAkSDgoGYWNjZXNzGAIgASgJEiUKBmV4dHJhcxj/ASADKAsyFC5nb29nbGUucHJvdG9idWYuQW55IiYKE1JlZnJlc2hUb2tlblJlcXVlc3QSDwoHcmVmcmVzaBgBIAEoCSJNChRSZWZyZXNoVG9rZW5SZXNwb25zZRIOCgZhY2Nlc3MYASABKAkSJQoGZXh0cmFzGP8BIAMoCzIULmdvb2dsZS5wcm90b2J1Zi5Bbnky3wEKEVNpbXBsZUF1dGhTZXJ2aWNlElsKBlNpZ25JbhInLnBpbnVwLmdvb2dsZV9hdXRoLnNpbXBsZS5TaWduSW5SZXF1ZXN0GigucGludXAuZ29vZ2xlX2F1dGguc2ltcGxlLlNpZ25JblJlc3BvbnNlEm0KDFJlZnJlc2hUb2tlbhItLnBpbnVwLmdvb2dsZV9hdXRoLnNpbXBsZS5SZWZyZXNoVG9rZW5SZXF1ZXN0Gi4ucGludXAuZ29vZ2xlX2F1dGguc2ltcGxlLlJlZnJlc2hUb2tlblJlc3BvbnNlQjRaMmdpdC50aW1lMmdvLnRlY2gvYXBpcy9nZW4vcGludXAvZ29vZ2xlLWF1dGgvc2ltcGxlYgZwcm90bzM", [file_google_protobuf_any]);

/**
 * Describes the message pinup.google_auth.simple.SignInRequest.
 * Use `create(SignInRequestSchema)` to create a new message.
 */
export const SignInRequestSchema = /*@__PURE__*/
  messageDesc(file_admin_auth_main_pinup_google_auth_simple_service, 0);

/**
 * Describes the message pinup.google_auth.simple.SignInResponse.
 * Use `create(SignInResponseSchema)` to create a new message.
 */
export const SignInResponseSchema = /*@__PURE__*/
  messageDesc(file_admin_auth_main_pinup_google_auth_simple_service, 1);

/**
 * Describes the message pinup.google_auth.simple.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema = /*@__PURE__*/
  messageDesc(file_admin_auth_main_pinup_google_auth_simple_service, 2);

/**
 * Describes the message pinup.google_auth.simple.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema = /*@__PURE__*/
  messageDesc(file_admin_auth_main_pinup_google_auth_simple_service, 3);

/**
 * @generated from service pinup.google_auth.simple.SimpleAuthService
 */
export const SimpleAuthService = /*@__PURE__*/
  serviceDesc(file_admin_auth_main_pinup_google_auth_simple_service, 0);

